// extracted by mini-css-extract-plugin
export var tag = "styles-module__tag___zcf67";